import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import BrandedSplash from '@/components/BrandedSplash';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <BrandedSplash />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}
